import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
var TableCell = /** @class */ (function (_super) {
    __extends(TableCell, _super);
    function TableCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableCell.prototype.render = function () {
        var props = this.props;
        var isActionCell = props.actionsCell ? 'actions-cell' : '';
        var classNames = namespacedClassnames(props.className, 'table-cell', isActionCell);
        var style = {
            width: props.width
        };
        var clickActionsCell = function (e) {
            if (props.actionsCell && props.onClickActionCell) {
                e.preventDefault();
                e.stopPropagation();
                props.onClickActionCell();
            }
        };
        return (React.createElement("div", { className: classNames, style: style, onClick: clickActionsCell }, props.children));
    };
    return TableCell;
}(React.Component));
export { TableCell };
//# sourceMappingURL=table-cell.js.map